// src/components/OrgAtamaBilesi.js
// Kullanım: PersonelKartiPage.js içinde <OrgAtamaBilesi kullaniciId={...} /> olarak ekle

import React, { useState, useEffect, useCallback } from 'react';

const API = '';

export default function OrgAtamaBilesi({ kullaniciId }) {
  const [atamalar, setAtamalar] = useState([]);
  const [departmanlar, setDepartmanlar] = useState([]);
  const [pozisyonlar, setPozisyonlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [atamaModalAcik, setAtamaModalAcik] = useState(false);
  const [bitirModalAcik, setBitirModalAcik] = useState(false);
  const [seciliAtama, setSeciliAtama] = useState(null);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');
  const [form, setForm] = useState({
    pozisyon_id: '', baslangic_tarihi: '', birincil: true, notlar: ''
  });
  const [bitirTarihi, setBitirTarihi] = useState('');

  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  const getir = useCallback(async () => {
    try {
      setYukleniyor(true);
      const [atamaR, depR] = await Promise.all([
        fetch(`${API}/api/organizasyon/atama/${kullaniciId}`, { headers }),
        fetch(`${API}/api/organizasyon/departmanlar`, { headers })
      ]);
      const [ata, dep] = await Promise.all([atamaR.json(), depR.json()]);
      setAtamalar(Array.isArray(ata) ? ata : []);
      setDepartmanlar(Array.isArray(dep) ? dep : []);
    } catch { setHata('Veriler yüklenemedi'); }
    finally { setYukleniyor(false); }
  }, [kullaniciId]);

  useEffect(() => { getir(); }, [getir]);

  const depSecilince = async (depId) => {
    setForm(f => ({ ...f, departman_id: depId, pozisyon_id: '' }));
    if (!depId) { setPozisyonlar([]); return; }
    try {
      const r = await fetch(`${API}/api/organizasyon/pozisyonlar?departman_id=${depId}`, { headers });
      const d = await r.json();
      setPozisyonlar(Array.isArray(d) ? d : []);
    } catch { setPozisyonlar([]); }
  };

  const atamaYap = async () => {
    if (!form.pozisyon_id || !form.baslangic_tarihi) {
      setHata('Pozisyon ve başlangıç tarihi zorunludur'); return;
    }
    try {
      const r = await fetch(`${API}/api/organizasyon/atama/${kullaniciId}`, {
        method: 'POST', headers,
        body: JSON.stringify({
          pozisyon_id: parseInt(form.pozisyon_id),
          baslangic_tarihi: form.baslangic_tarihi,
          birincil: form.birincil ? 1 : 0,
          notlar: form.notlar || null
        })
      });
      const d = await r.json();
      if (!r.ok) { setHata(d.hata || 'Hata oluştu'); return; }
      setBasari('Pozisyon atandı');
      setTimeout(() => { setAtamaModalAcik(false); getir(); setHata(''); setBasari(''); }, 800);
    } catch { setHata('Sunucu hatası'); }
  };

  const atamaaBitir = async () => {
    if (!bitirTarihi) { setHata('Bitiş tarihi zorunludur'); return; }
    try {
      const r = await fetch(`${API}/api/organizasyon/atama/${seciliAtama.id}/bitir`, {
        method: 'PATCH', headers,
        body: JSON.stringify({ bitis_tarihi: bitirTarihi })
      });
      const d = await r.json();
      if (!r.ok) { setHata(d.hata || 'Hata oluştu'); return; }
      setBitirModalAcik(false);
      getir();
    } catch { setHata('Sunucu hatası'); }
  };

  const aktifAtamalar = atamalar.filter(a => !a.bitis_tarihi);
  const gecmisAtamalar = atamalar.filter(a => a.bitis_tarihi);

  return (
    <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
      {/* Başlık */}
      <div style={{
        padding: '16px 20px', borderBottom: '1px solid #F3F4F6',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        background: '#FAFAFA'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '18px' }}>🏢</span>
          <span style={{ fontWeight: 700, fontSize: '15px', color: '#111827' }}>Organizasyon & Pozisyon</span>
        </div>
        <button
          onClick={() => {
            setForm({ pozisyon_id: '', baslangic_tarihi: new Date().toISOString().slice(0,10), birincil: true, notlar: '' });
            setPozisyonlar([]);
            setHata(''); setBasari('');
            setAtamaModalAcik(true);
          }}
          style={{
            background: '#4F46E5', color: '#fff', border: 'none',
            padding: '7px 14px', borderRadius: '6px', cursor: 'pointer', fontWeight: 600, fontSize: '13px'
          }}
        >+ Pozisyon Ata</button>
      </div>

      <div style={{ padding: '16px 20px' }}>
        {yukleniyor ? (
          <div style={{ textAlign: 'center', padding: '20px', color: '#9CA3AF' }}>Yükleniyor...</div>
        ) : (
          <>
            {/* Aktif atamalar */}
            {aktifAtamalar.length === 0 ? (
              <div style={{
                textAlign: 'center', padding: '24px', background: '#F9FAFB',
                borderRadius: '8px', border: '1.5px dashed #E5E7EB'
              }}>
                <p style={{ color: '#9CA3AF', fontSize: '14px', margin: 0 }}>
                  Henüz pozisyon atanmamış
                </p>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {aktifAtamalar.map(a => (
                  <div key={a.id} style={{
                    background: a.birincil ? '#EEF2FF' : '#F9FAFB',
                    border: `1.5px solid ${a.birincil ? '#C7D2FE' : '#E5E7EB'}`,
                    borderRadius: '10px', padding: '12px 16px',
                    display: 'flex', alignItems: 'center', gap: '12px'
                  }}>
                    <div style={{
                      width: '8px', height: '8px', borderRadius: '50%',
                      background: a.departman_renk || '#4F46E5', flexShrink: 0
                    }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <span style={{ fontWeight: 700, color: '#111827', fontSize: '14px' }}>{a.pozisyon_ad}</span>
                        {a.birincil && (
                          <span style={{
                            background: '#4F46E5', color: '#fff',
                            fontSize: '10px', padding: '2px 8px', borderRadius: '4px', fontWeight: 700
                          }}>BİRİNCİL</span>
                        )}
                        <span style={{
                          background: (a.departman_renk || '#4F46E5') + '20',
                          color: a.departman_renk || '#4F46E5',
                          fontSize: '11px', padding: '2px 8px', borderRadius: '4px', fontWeight: 600
                        }}>{a.departman_ad}</span>
                      </div>
                      <div style={{ color: '#6B7280', fontSize: '12px', marginTop: '2px' }}>
                        📅 {new Date(a.baslangic_tarihi).toLocaleDateString('tr-TR')} tarihinden itibaren
                        {a.pozisyon_kod && <span style={{ marginLeft: '8px', fontFamily: 'monospace', background: '#F3F4F6', padding: '1px 6px', borderRadius: '3px' }}>{a.pozisyon_kod}</span>}
                      </div>
                      {a.notlar && <div style={{ color: '#9CA3AF', fontSize: '11px', marginTop: '2px' }}>📝 {a.notlar}</div>}
                    </div>
                    <button
                      onClick={() => { setSeciliAtama(a); setBitirTarihi(new Date().toISOString().slice(0,10)); setHata(''); setBitirModalAcik(true); }}
                      style={{
                        background: '#FEF2F2', color: '#DC2626', border: 'none',
                        padding: '5px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: 600
                      }}
                    >Sonlandır</button>
                  </div>
                ))}
              </div>
            )}

            {/* Geçmiş atamalar */}
            {gecmisAtamalar.length > 0 && (
              <div style={{ marginTop: '16px' }}>
                <p style={{ fontSize: '12px', fontWeight: 600, color: '#9CA3AF', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                  Geçmiş Atamalar
                </p>
                {gecmisAtamalar.map(a => (
                  <div key={a.id} style={{
                    background: '#F9FAFB', border: '1px solid #F3F4F6',
                    borderRadius: '8px', padding: '10px 14px', marginBottom: '6px',
                    display: 'flex', alignItems: 'center', gap: '10px', opacity: 0.7
                  }}>
                    <span style={{ fontSize: '13px', color: '#6B7280', flex: 1 }}>
                      <s>{a.pozisyon_ad}</s> — {a.departman_ad}
                    </span>
                    <span style={{ fontSize: '11px', color: '#9CA3AF' }}>
                      {new Date(a.baslangic_tarihi).toLocaleDateString('tr-TR')} → {new Date(a.bitis_tarihi).toLocaleDateString('tr-TR')}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </div>

      {/* Atama Modal */}
      {atamaModalAcik && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '28px',
            width: '100%', maxWidth: '460px',
            boxShadow: '0 25px 50px rgba(0,0,0,0.25)'
          }}>
            <h2 style={{ fontSize: '18px', fontWeight: 700, margin: '0 0 20px' }}>💼 Pozisyon Ata</h2>

            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}
            {basari && <div style={{ background: '#F0FDF4', color: '#16A34A', padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>✅ {basari}</div>}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {/* Departman seç */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Departman *</label>
                <select
                  onChange={e => depSecilince(e.target.value)}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                >
                  <option value="">— Departman seçin —</option>
                  {departmanlar.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                </select>
              </div>

              {/* Pozisyon seç */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Pozisyon *</label>
                <select
                  value={form.pozisyon_id}
                  onChange={e => setForm(f => ({ ...f, pozisyon_id: e.target.value }))}
                  disabled={pozisyonlar.length === 0}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                >
                  <option value="">— Pozisyon seçin —</option>
                  {pozisyonlar.map(p => <option key={p.id} value={p.id}>{p.ad} (Lv.{p.seviye})</option>)}
                </select>
              </div>

              {/* Başlangıç tarihi */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Başlangıç Tarihi *</label>
                <input
                  type="date" value={form.baslangic_tarihi}
                  onChange={e => setForm(f => ({ ...f, baslangic_tarihi: e.target.value }))}
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                />
              </div>

              {/* Birincil */}
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', userSelect: 'none' }}>
                <input
                  type="checkbox" checked={form.birincil}
                  onChange={e => setForm(f => ({ ...f, birincil: e.target.checked }))}
                  style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                />
                <span style={{ fontSize: '14px', color: '#374151' }}>
                  Birincil pozisyon olarak ata
                  <span style={{ color: '#9CA3AF', fontSize: '12px', marginLeft: '6px' }}>(mevcut birincil sonlanır)</span>
                </span>
              </label>

              {/* Notlar */}
              <div>
                <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Notlar</label>
                <input value={form.notlar} onChange={e => setForm(f => ({ ...f, notlar: e.target.value }))}
                  placeholder="Opsiyonel not..."
                  style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setAtamaModalAcik(false)} style={{
                flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB',
                background: '#fff', cursor: 'pointer', fontWeight: 600
              }}>İptal</button>
              <button onClick={atamaYap} style={{
                flex: 2, padding: '10px', borderRadius: '8px', border: 'none',
                background: '#4F46E5', color: '#fff', cursor: 'pointer', fontWeight: 600
              }}>Ata</button>
            </div>
          </div>
        </div>
      )}

      {/* Bitir Modal */}
      {bitirModalAcik && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}>
          <div style={{
            background: '#fff', borderRadius: '16px', padding: '28px',
            width: '100%', maxWidth: '380px',
            boxShadow: '0 25px 50px rgba(0,0,0,0.25)'
          }}>
            <h2 style={{ fontSize: '18px', fontWeight: 700, margin: '0 0 8px' }}>Pozisyonu Sonlandır</h2>
            <p style={{ color: '#6B7280', fontSize: '14px', marginBottom: '20px' }}>
              <strong>{seciliAtama?.pozisyon_ad}</strong> pozisyonu için bitiş tarihi girin.
            </p>

            {hata && <div style={{ background: '#FEF2F2', color: '#DC2626', padding: '10px 14px', borderRadius: '8px', marginBottom: '14px', fontSize: '14px' }}>⚠️ {hata}</div>}

            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: '#374151', display: 'block', marginBottom: '6px' }}>Bitiş Tarihi *</label>
              <input
                type="date" value={bitirTarihi}
                onChange={e => setBitirTarihi(e.target.value)}
                style={{ width: '100%', padding: '10px 12px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
              <button onClick={() => setBitirModalAcik(false)} style={{
                flex: 1, padding: '10px', borderRadius: '8px', border: '1.5px solid #E5E7EB',
                background: '#fff', cursor: 'pointer', fontWeight: 600
              }}>İptal</button>
              <button onClick={atamaaBitir} style={{
                flex: 2, padding: '10px', borderRadius: '8px', border: 'none',
                background: '#DC2626', color: '#fff', cursor: 'pointer', fontWeight: 600
              }}>Sonlandır</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
